import { Component, OnInit, Inject, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { takeUntil, filter } from 'rxjs/operators';
import { documentFormConfig } from '../edit-document/edit-document.component';
import { Document } from 'src/shared/api';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

/*
	TODO come up with a better approach to this. Right now I _need_
	a FormGroup type back from this dialog. Only problem is it's
	accessing values from components that implement the CVA, which
	can only be listened to through a FormControl. So I'm having to
	do some manual mapping from formcontrol to formgroup.
*/

@Component({
	selector: 'rpshared-edit-document-dialog',
	templateUrl: './edit-document-dialog.component.html',
})
export class EditDocumentDialogComponent extends SelfDestruct
	implements OnInit {
	// CVA components can only be listened to through a form control
	control = new FormControl('') as FormControl;

	group = this.fb.group(documentFormConfig) as FormGroup;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		@Optional()
		private readonly document: Document,
		private readonly fb: FormBuilder
	) {
		super();
	}

	ngOnInit() {
		this.control.valueChanges
			.pipe(filter(Boolean), takeUntil(this.destroyed))
			.subscribe((v) => this.group.patchValue(v));

		if (this.document) {
			this.control.setValue(this.document);
		}
	}
}
